import { z } from 'zod';
import { ChannelSchema, DefinitionStatusSchema, FieldDefinitionSchema } from './schema';
import { ZoneDefinitionSchema } from './zone-definition';
export const ModuleDefinitionSchema = z.object({
    label: z.string(),
    description: z.string(),
    status: DefinitionStatusSchema,
    channels: z.array(ChannelSchema),
    fieldDefinitions: z.array(FieldDefinitionSchema),
    zonesDefinitions: z.array(ZoneDefinitionSchema).optional(),
    validations: z
        .object({
        surfaceRestrictions: z
            .array(z.object({
            name: z.string().optional(),
            version: z.string().optional()
        }))
            .optional()
    })
        .optional()
});
export const ModuleDefinitionVersionSchema = z.record(z.string(), ModuleDefinitionSchema);
export const WebModuleDefinitionSchema = z.object({
    name: z.string(),
    schema: z.string(),
    type: z.literal('module'),
    versions: ModuleDefinitionVersionSchema
});
/**
 * Create a versioned module from a module definition json.
 * @param  definition  Module definition json, conforming with ModuleDefinition type.
 * @returns - Module definition object.
 * @example
 * ```ts
 *    import { createModuleDefinitionVersion } from "@atlassiansox/bxp-definition-sdk";
 *
 *    export const ExampleWebModule = createModuleDefinitionVersion({
 *      {
 *         label: 'signup-wac',
 *         description: 'Test module description',
 *         status: 'active',
 *         channels: ['web', 'mobile'],
 *         fieldDefinitions: [
 *             {
 *              type: "string",
 *              name: "title",
 *              validations: {
 *                isRequired: true,
 *              }
 *            },
 *            {
 *              type: "boolean",
 *              name: "isProduction",
 *              validations: {
 *                isRequired: true,
 *              }
 *            }
 *         ]
 *       }
 *    });
 * ```
 */
export function createModuleDefinitionVersion(moduleDefinition) {
    return ModuleDefinitionSchema.parse(moduleDefinition);
}
//# sourceMappingURL=web-module-definition.js.map